import {createSelector} from 'reselect';

const getExperiment = state => state.start.siteDataV2.clientExperiments;
export const getIsContactNumberOptionalExperiment = createSelector(
  [getExperiment],
  experiment => experiment?.contact_number_optional_wave_01 === 'v1|contact_number_optional',
);
